<footer role="contentinfo">
  <h2>{{ "DIPRSRegistration.footer.title" | translate }}</h2>
  <p>
    <span [innerHTML]="'DIPRSRegistration.footer.information.part1'|
      translate : {phoneNumber: phoneNumber}"></span><br>
    {{ "DIPRSRegistration.footer.information.part2" | translate }}<br>
    {{ "DIPRSRegistration.footer.information.part3" | translate }}<br>
    {{ "DIPRSRegistration.footer.information.part4" | translate }}
  </p>
   <div>
    <nav>
      <a [href]="'DIPRSRegistration.footer.privacy.link' | translate" target="_blank">
        {{ "DIPRSRegistration.footer.privacy" | translate }}
      </a>
      <a [href]="'DIPRSRegistration.footer.legal.link' | translate" target="_blank">
        {{ "DIPRSRegistration.footer.legal" | translate }}
      </a>
      <a [href]="'DIPRSRegistration.footer.accessibility.link' | translate" target="_blank">
        {{ "DIPRSRegistration.footer.accessibility" | translate }}
      </a>
      <a [href]="'DIPRSRegistration.footer.our.companies.link' | translate" target="_blank">
        {{ "DIPRSRegistration.footer.companies" | translate }}
      </a>
      <a *ngIf="showCookieSettings" class="ot-sdk-show-settings" >
        {{'DIPRSRegistration.footer.cookie.settings' | translate}}
      </a>
    </nav>
   </div>
  <img src="assets/images/td-chair.png" alt="TD green chair">
</footer>
